import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";
import { Paginated } from "../../models";
import {
  AssignmentDto,
  CreateAssignmentRequest,
  UpdateAssignmentRequest,
} from "../../interfaces/lecture/assignment";

export const lectureAssignmentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLectureAssignments: builder.query<
      Paginated<AssignmentDto>,
      { data: PaginateQuery; lectureId: string }
    >({
      query: ({ data, lectureId }) => ({
        url: buildPaginationQueryString(
          data,
          `/api/assignment/lecture/${lectureId}`,
        ),
      }),
      providesTags: ["Paginated-Lecture-Assignment"],
    }),
    getLectureAssignment: builder.query<AssignmentDto, string>({
      query: (id) => ({ url: `/api/assignment/${id}` }),
      providesTags: ["LectureAssignment"],
    }),
    addLectureAssignment: builder.mutation<
      any,
      { lectureId: string; data: CreateAssignmentRequest }
    >({
      query: ({ lectureId, data }) => ({
        url: `/api/assignment/lecture/${lectureId}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Paginated-Lecture-Assignment"],
    }),
    updateLectureAssignment: builder.mutation<
      any,
      { id: string; data: UpdateAssignmentRequest }
    >({
      query: ({ id, data }) => ({
        url: `/api/assignment/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["LectureAssignment", "Paginated-Lecture-Assignment"],
    }),
    deleteLectureAssignment: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/assignment/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-Lecture-Assignment"],
    }),
    toggleLectureAssignmentState: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/assignment/${id}/toggle-state`,
        method: "PATCH",
        body: {},
      }),
      invalidatesTags: ["Paginated-Lecture-Assignment"],
    }),
  }),
});

export const {
  useGetLectureAssignmentsQuery,
  useGetLectureAssignmentQuery,
  useAddLectureAssignmentMutation,
  useUpdateLectureAssignmentMutation,
  useDeleteLectureAssignmentMutation,
  useToggleLectureAssignmentStateMutation,
  useLazyGetLectureAssignmentQuery,
} = lectureAssignmentApi;
